import { render, staticRenderFns } from "./switchCard.vue?vue&type=template&id=0a0304f4&"
import script from "./switchCard.vue?vue&type=script&lang=js&"
export * from "./switchCard.vue?vue&type=script&lang=js&"
import style0 from "./switchCard.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports